import { apiClient } from '../../axios';
import {
  DeleteAllTpslOrdersApiParams,
  DeleteAllTpslOrdersApiResponse,
  DeleteMultiOpenPositionParams,
  DeleteMultiOpenPositionResponse,
  DeleteOpenPositionParams,
  DeleteOpenPositionResponse,
  DeletePendingPositionParams,
  DeletePendingPositionResponse,
  PostAddPositionParams,
  PostOneWayCloseOrderParams,
  PostOneWayCloseOrderResponse,
  PostOneWayCloseOrderSymbolParams,
  PostOneWayCloseOrderSymbolResponse,
  PostOneWayConditionalOrderParams,
  PostOneWayConditionalOrderResponse,
  PostOneWayFlipParams,
  PostOneWayOrderParams,
  PostOneWayOrderResponse,
  PostOneWayPartialTpSlResponse,
  PostOneWayPartialTpslParams,
  PostOneWayTpslParams,
  PostOrderParams,
  PostOrderPartialTpSlResponse,
  PostOrderPartialTpslParams,
  PostOrderResponse,
  PostPositionParams,
  PostPositionResponse,
  PostProfitBoostParams,
  PostSpotMarketOrderParams,
  PostSpotMarketOrderResponse,
  PostSpotOrderParams,
  PostSpotOrderResponse,
  PutAdjustLeverageParams,
  PutAdjustMarginParams,
  PutAmendOrderPriceParams,
  PutAmendOrderPriceResponse,
  PutInstantFlipParams,
  PutOpenPositionParams,
  PutOpenPositionResponse,
  PutOrderPartialTpslParams,
  PutOrderPartialTpslResponse,
  PutOrderTpSlParams,
  PutTradeModeParams,
} from './types';

export const postPositionApi = (symbol: string, params: PostPositionParams) =>
  apiClient.post<PostPositionResponse>(`/v2/trade/positions/${symbol}`, params);

export const postAddPositionApi = (symbol: string, slot: number, params: PostAddPositionParams) =>
  apiClient.post<PostPositionResponse>(`/v2/trade/positions/${symbol}/${slot}`, params);

export const postOrderApi = (symbol: string, params: PostOrderParams) =>
  apiClient.post<PostOrderResponse>(`/v2/trade/orders/${symbol}`, params);

export const putOpenPositionApi = (symbol: string, slot: number, params: PutOpenPositionParams) =>
  apiClient.put<PutOpenPositionResponse>(`/v2/trade/positions/${symbol}/${slot}/size`, params);

/**
 * @deprecated 콜사이트 0 — 포지션 종료는 `putOpenPositionApi`(size 조정)로 일원화됨. 삭제 후보. (trade-actions-migration-followups §4)
 */
export const deleteOpenPositionApi = (symbol: string, slot: number, params: DeleteOpenPositionParams) =>
  apiClient.delete<DeleteOpenPositionResponse>(`/v2/trade/positions/${symbol}/${slot}`, { data: params });

export const deletePendingPositionApi = (symbol: string, orderId: string, params: DeletePendingPositionParams) =>
  apiClient.delete<DeletePendingPositionResponse>(`/v2/trade/orders/${symbol}/${orderId}`, { data: params });

export const deleteMultiOpenPositions = (params: DeleteMultiOpenPositionParams) =>
  apiClient.delete<DeleteMultiOpenPositionResponse>('/v2/trade/positions', { data: params });

export const putInstantFlipApi = (symbol: string, slot: number, params: PutInstantFlipParams) =>
  apiClient.put(`/v2/trade/positions/${symbol}/${slot}/side`, params);

export const putOrderTpSlApi = (symbol: string, orderId: string, params: PutOrderTpSlParams) =>
  apiClient.put(`/v2/trade/orders/${symbol}/${orderId}/tpsl`, params);

export const putAdjustMarginApi = (symbol: string, slot: number, params: PutAdjustMarginParams) =>
  apiClient.put(`/v2/trade/positions/${symbol}/${slot}/margin`, params);

export const putAdjustLeverageApi = (symbol: string, slot: number, params: PutAdjustLeverageParams) =>
  apiClient.put(`/v2/trade/positions/${symbol}/${slot}/leverage`, params);
// Spot
export const postSpotMarketOrderApi = (symbol: string, params: PostSpotMarketOrderParams) =>
  apiClient.post<PostSpotMarketOrderResponse>(`/v2/trade/spots/${symbol}`, params);

export const postSpotOrderApi = (symbol: string, params: PostSpotOrderParams) =>
  apiClient.post<PostSpotOrderResponse>(`/v2/trade/orders/spot/${symbol}`, params);

export const putTradeModeApi = (params: PutTradeModeParams) => apiClient.put('/v2/trade/mode', params);

/**
 * One-way mode
 * https://www.notion.so/prextech/Client-requirements-for-trade-152eb32ad22780aeaee9e7e7c3f37419?pvs=4
 */
// POST api/v2/trade/positions/${symbol} <-> POST api/v2/trade/one-way/order/${symbol}
export const postOneWayOrderApi = (symbol: string, params: PostOneWayOrderParams) =>
  apiClient.post<PostOneWayOrderResponse>(`/v2/trade/one-way/order/${symbol}`, params);

// DELETE api/v2/trade/positions/${symbol}/${slot} <-> POST api/v2/trade/one-way/close-order/${symbol}
/**
 * @deprecated 콜사이트 0 — one-way 종료는 `postOneWayCloseOrderApi`(전체)로 처리됨. 삭제 후보. (trade-actions-migration-followups §4)
 */
export const postOneWayCloseOrderSymbolApi = (symbol: string, params: PostOneWayCloseOrderSymbolParams) =>
  apiClient.post<PostOneWayCloseOrderSymbolResponse>(`/v2/trade/one-way/close-order/${symbol}`, params);

// DELETE api/v2/trade/positions <-> POST api/v2/trade/one-way/close-order
export const postOneWayCloseOrderApi = (params: PostOneWayCloseOrderParams) =>
  apiClient.post<PostOneWayCloseOrderResponse>('/v2/trade/one-way/close-order', params);

// PUT api/v2/trade/positions/${symbol}/${slot}/side <-> POST api/v2/trade/one-way/flip-order/${symbol}
export const postOneWayFlipApi = (symbol: string, params: PostOneWayFlipParams) =>
  apiClient.post(`/v2/trade/one-way/flip-order/${symbol}`, params);

// POST api/v2/trade/orders/${symbol} <-> POST api/v2/trade/one-way/tpsl/${symbol}
export const postOneWayTpslApi = (symbol: string, params: PostOneWayTpslParams) =>
  apiClient.post(`/v2/trade/one-way/tpsl/${symbol}`, params);

// POST api/v2/trade/orders/${symbol} <-> POST api/v2/trade/one-way/conditional-order/${symbol}
export const postOneWayConditionalOrderApi = (symbol: string, params: PostOneWayConditionalOrderParams) =>
  apiClient.post<PostOneWayConditionalOrderResponse>(`/v2/trade/one-way/conditional-order/${symbol}`, params);

export const postProfitBoostApi = (symbol: string, slot: number, params: PostProfitBoostParams) =>
  apiClient.post(`/v2/trade/positions/${symbol}/${slot}/boost`, params);

// partial tp/sl
export const postOrderPartialTpslApi = (symbol: string, params: PostOrderPartialTpslParams) =>
  apiClient.post<PostOrderPartialTpSlResponse>(`/v2/trade/orders/${symbol}/partial-tpsl`, params);

export const putOrderPartialTpslApi = (symbol: string, orderId: string, params: PutOrderPartialTpslParams) =>
  apiClient.put<PutOrderPartialTpslResponse>(`/v2/trade/orders/${symbol}/partial-tpsl/${orderId}`, params);

export const postOneWayPartialTpslApi = (symbol: string, params: PostOneWayPartialTpslParams) =>
  apiClient.post<PostOneWayPartialTpSlResponse>(`/v2/trade/one-way/partial-tpsl/${symbol}`, params);

export const deleteAllTpslOrdersApi = (params: DeleteAllTpslOrdersApiParams) =>
  apiClient.delete<DeleteAllTpslOrdersApiResponse>(`/v2/trade/orders`, { data: params });

export const putAmendOrderPriceApi = (symbol: string, orderId: string, params: PutAmendOrderPriceParams) =>
  apiClient.put<PutAmendOrderPriceResponse>(`/v2/trade/orders/${symbol}/${orderId}/amend`, params);
